import { Injectable } from '@angular/core';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import { SeguretatUsuarisFilter } from '../models/seguretat-usuaris-filter';

const defaultSortParam = 'CodUser';
const defaultSortDirection = 'asc';

@Injectable()
export class SeguretatUsuarisFilterService extends CustomFilterService {
  public createFilterParams(filter: SeguretatUsuarisFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {

    return new HttpParams()
    .append('codiUser', (filter.codiUser ? filter.codiUser.toString() : ''))
    .append('nomUsuari', filter.nomUsuari)
    .append('descripcio', filter.descripcio)
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
